import React from 'react'
import { Skeleton } from '@duck/ui'

export const UserDetailSkeleton: React.FC = () => {
  return (
    <div className="space-y-6 p-4">
      {/* Header title + subtitle */}
      <div className="space-y-2">
        <Skeleton className="h-7 w-64" />
        <Skeleton className="h-4 w-40" />
      </div>

      {/* Overview cards layout */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {/* Left card: identity */}
        <div className="bg-card border border-border rounded-lg p-4 flex flex-col gap-4">
          <div className="flex gap-4 items-start">
            <Skeleton className="h-14 w-14 rounded-full" />
            <div className="flex-1 space-y-3">
              <Skeleton className="h-5 w-40" />
              <Skeleton className="h-4 w-64" />
              <Skeleton className="h-3 w-56" />
            </div>
          </div>
          <div className="space-y-2">
            <Skeleton className="h-16 w-full" />
          </div>
        </div>

        {/* Right card: meta info */}
        <div className="bg-card border border-border rounded-lg p-4 text-sm">
          <div className="flex flex-col sm:flex-row gap-4 h-full">
            <div className="flex flex-col flex-1 space-y-3">
              <Skeleton className="h-3 w-20" />
              <Skeleton className="h-4 w-32" />
              <Skeleton className="h-3 w-24" />
              <Skeleton className="h-4 w-28" />
              <Skeleton className="h-3 w-24" />
              <Skeleton className="h-4 w-24" />
            </div>
            <div className="flex flex-col flex-1 space-y-3">
              <Skeleton className="h-3 w-20" />
              <Skeleton className="h-6 w-24 rounded-full" />
              <Skeleton className="h-3 w-24" />
              <Skeleton className="h-6 w-28 rounded-full" />
              <Skeleton className="h-3 w-28" />
              <Skeleton className="h-6 w-24 rounded-full" />
            </div>
          </div>
        </div>
      </div>

      {/* Basic information section */}
      <div className="space-y-4">
        <Skeleton className="h-6 w-40" />
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-10 w-full" />
          </div>
          <div className="space-y-2">
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-10 w-full" />
          </div>
          <div className="space-y-2">
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-10 w-full" />
          </div>
          <div className="flex items-center gap-6 pt-6">
            <Skeleton className="h-5 w-24" />
            <Skeleton className="h-5 w-28" />
          </div>
        </div>
      </div>
    </div>
  )
}

